import React from 'react';
import { Card } from 'antd';
import './RiskWarning.css'
import {Layout, Typography} from 'antd';
import exampleImage from '../images/serialcode-info.png';
const { Content } = Layout;

const { Text, Title, Paragraph } = Typography;


function RiskWarning() {
    const mobileNumber = "18101195395  ";
    const phoneNumber = "010-65906290"
    return (
        <div className="container">
            <Card title={<div style={{ textAlign: 'center', fontSize: '24px', marginTop:'20px', marginBottom:'20px'}}>⚠风险警告</div>}
            className="risk-card" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <Typography className='content'>
                    <Paragraph>
                    尊敬的客户您好！
                    </Paragraph>
                    <Paragraph>
                    感谢您对我们产品的关注与支持。在此，我们特别提醒您关于我司防伪标签查询的重要信息，以确保您能享受到正品带来的优质服务与保障。
                    </Paragraph>
                    <Paragraph>
                    我司防伪标签系统设计有严格的查询机制，旨在保护每一位消费者的合法权益。
                    当您或您公司人员通过我司官方防伪标签查询页面输入防伪编码进行查询时，
                    页面不仅会显示该编码的有效性，还会明确告知该编码被查询的次数记录。这一功能是我们鉴别产品真伪的重要一环，
                    如果您在查询过程中发现，您实际查询的次数与页面显示的查询次数不符，
                    这极可能意味着该防伪编码对应的产品存在被仿冒的风险。这种情况下，产品的真实性及来源可靠性均需进一步核实。
                    </Paragraph>
                    <Paragraph>
                    为确保您的权益不受侵害，我们强烈建议您在发现上述不符情况时，立即致电我司进行进一步的确认与咨询。
                    我们的专业团队将迅速响应，为您提供详尽的验证服务及必要的后续处理措施。
                    </Paragraph>
                   
                    <Paragraph>
                    在此，我们郑重声明：目前市场上出现了多起仿冒我司产品的恶劣行为，
                    这些仿冒产品不仅严重威胁到用户设备的安全，更严重损害了用户的合法权益，
                    并触犯了相关法律法规。我司对此类行为持零容忍态度，并将采取一切必要措施予以打击。
                    </Paragraph>
                    <Paragraph>
                    同时，我们诚挚邀请广大用户积极提供仿冒产品的相关线索。一经查实，
                    我司将对线索提供者给予相应的奖励，并严格确保线索提供者的个人隐私安全。
                    </Paragraph>
                    <Paragraph>
                    以下是我们的联系方式，请随时与我们取得联系：
                    <br />
                    
                    {mobileNumber} 李先生
                    <br />
                    
                    {phoneNumber}
                    
                    </Paragraph>
                    <Paragraph>
                    感谢您的理解与支持！
                    </Paragraph>
</Typography>
                
<p style={{fontSize: '18px',textAlign: 'right'}}>哈斯科亚太铁路机械商贸（北京）有限公司 </p>
<br />
<p className = "exampleTitle">图示样例</p>
<img src={exampleImage} alt="Serial Code Info" style={{ width: '100%', height: 'auto' }}/>
            </Card>
        </div>
    );
}


export default RiskWarning;